export default __webpack_public_path__ + "static/media/prof.8b329c7e.svg";